export const MockAppInfo = {
  info: {
    app: {
      deviceIdentity: "C901C8B0-8C6D-41B2-9843-057D000C9181",
      appVersionCode: "224202",
      locale: "en-CA",
      country: "CA",
      userAgent: "TowneersApp/22.42.2/224202 iOS/16.0.2/1946.102 iPhone14,8",
      appHost: "webapp.alpha.ca.karrotmarket.com",
      appVersion: "22.42.2"
    }
  }
}

export const MockUserInfo = {
  info: {
    user: {
      hasProfileImageSet: false,
      createdAt: "2022-11-08T16:22:45.217+09:00",
      lastActivityName: "Active in the last 3 days",
      phoneVerifiedAt: "2022-11-08T16:22:31.706+09:00",
      status: "active",
      displayLocationName: "Bay Street Corridor",
      fleaMarketArticlesCount: 0,
      authToken: "6e7d51547ffccc73ec58e43f0742abda1d45483bf4f5fb849586c9ad211c6fbd",
      accountType: "normal",
      userExtend: {
        issuedBadgesCount: 0,
        region2Range: "range3",
        adPaymentInApp: true,
        region2RangeDistance: 23000,
        isTester: false,
        region1Range: "range3",
        isSubNotificationOn: true,
        categoryIds: [
          34,
          37,
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          10,
          11,
          12,
          13
        ],
        isDoNotDisturbOn: false,
        webCrawlAllowed: true,
        region1: {
          name2Id: 12696,
          id: 12717,
          status: "opened",
          storyOpened: false,
          fullname: "Bay Street Corridor, Toronto",
          name1Id: 10077,
          meetupEnabled: false,
          type: "OfficialRegion",
          parentId: 12696,
          centerCoordinates: {
            longitude: -79.38572148495956,
            latitude: 43.65751225749332
          },
          name: "Bay Street Corridor",
          name3Id: 12717,
          name3: "Bay Street Corridor",
          defaultRange: "range3",
          name2: "Toronto",
          name1: "Ontario"
        },
        isMainNotificationOn: true,
        doNotDisturbStartTime: "23:00",
        marketingAgreedAt: "2022-11-08T16:22:45.200+09:00",
        doNotDisturbEndTime: "08:00",
        region1RangeDistance: 23000
      },
      businessArticlesCount: 0,
      locations: [],
      hashId: "YmxnykZpW6oGwEWQ",
      displayRegionCheckinsCount: 0,
      externalId: "GVVY",
      displayRegionName: "Bay Street Corridor",
      id: 1174,
      termsAgreedAt: "2022-11-08T16:22:45.200+09:00",
      nickname: "AstroUncheckin",
      region: {
        parentId: 12696,
        name1: "Ontario",
        name: "Bay Street Corridor",
        name2Id: 12696,
        type: "OfficialRegion",
        storyOpened: false,
        centerCoordinates: {
          latitude: 43.65751225749332,
          longitude: -79.38572148495956
        },
        name2: "Toronto",
        name3: "Bay Street Corridor",
        name3Id: 12717,
        id: 12717,
        defaultRange: "range3",
        meetupEnabled: false,
        fullname: "Bay Street Corridor, Toronto",
        status: "opened",
        name1Id: 10077
      },
      temperature: 30,
      profileImage: "https://dbfrsfg9duavi.cloudfront.net/assets/users/default_profile_640-bd77d547809e231cb246f9970970269851c8f0f0cb17fbbe8f6acf9fee1c3cc2.png",
      fleaMarketArticlesCountsByStatus: {
        ongoing: 0,
        closed: 0,
        invisible: 0
      },
      phone: "4183738838"
    }
  }
}
